"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.toEncodedSearchQueryString = exports.searchSeparator = void 0;
var _assign = _interopRequireDefault(require("lodash/assign"));
var _mapValues = _interopRequireDefault(require("lodash/mapValues"));
var _decode = _interopRequireWildcard(require("./decode"));
var _renameField = _interopRequireDefault(require("./rename-field"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const encoders = [function encodeHead() {
  return {
    V: '2',
    P: 'jobsearch'
  };
}, (0, _renameField.default)('keywords', 'K'), (0, _renameField.default)('where', 'WH'), (0, _renameField.default)('whereid', 'WID'), (0, _renameField.default)('classification', 'I'), (0, _renameField.default)('subclassification', 'O'), (0, _renameField.default)('sortmode', 'SORT'), function encodeSalaryType(_ref) {
  let {
    salarytype
  } = _ref;
  if (!salarytype) {
    return {};
  }
  switch (salarytype) {
    case 'hourly':
      return {
        SFT: 'SalaryHourly',
        SL: 'Hourly'
      };
    case 'monthly':
      return {
        SFT: 'SalaryMonthly',
        SL: 'Monthly'
      };
    default:
      return {
        SFT: 'Salary',
        SL: 'Annual'
      };
  }
}, function encodeSalary(_ref2) {
  let {
    salaryrange
  } = _ref2;
  if (!salaryrange || !/\d*-\d*/.test(salaryrange)) {
    return {};
  }
  const [SF, ST] = salaryrange.split('-');
  return {
    SF: SF || '0',
    ST: ST || '999999'
  };
}, (0, _renameField.default)('daterange', 'D'), (0, _renameField.default)('worktype', 'W'), (0, _renameField.default)('page', 'N'), (0, _renameField.default)('companyid', 'CID'), (0, _renameField.default)('nation', 'NA'), (0, _renameField.default)('location', 'L'), (0, _renameField.default)('area', 'A'), (0, _renameField.default)('advertiserid', 'ADV'), (0, _renameField.default)('advertisergroup', 'ADG'), (0, _renameField.default)('workarrangement', 'WA'), function encodeGraduateSearch(_ref3) {
  let {
    graduatesearch
  } = _ref3;
  return graduatesearch === 'true' ? {
    C: '1'
  } : {};
}, function encodeTail(query, date) {
  return {
    OSF: `quick&set=${date.getTime()}`
  };
}];
const searchSeparator = exports.searchSeparator = '/';
const toDecodedSearchQueries = encodedSearchQueriesStr => encodedSearchQueriesStr.split(searchSeparator).filter(searchQuery => (0, _decode.default)(searchQuery));
const isEqual = (decodedOfA, decodedOfB, key) => {
  var _decodedOfA$query$key, _decodedOfB$query$key;
  return ((_decodedOfA$query$key = decodedOfA.query[key]) === null || _decodedOfA$query$key === void 0 ? void 0 : _decodedOfA$query$key.toLowerCase()) === ((_decodedOfB$query$key = decodedOfB.query[key]) === null || _decodedOfB$query$key === void 0 ? void 0 : _decodedOfB$query$key.toLowerCase());
};
const filterDuplicateSearchQueries = encodedSearchQueries => encodedSearchQueries.map(encodedSearchQuery => [(0, _decode.decodeSearch)(encodedSearchQuery), encodedSearchQuery]).reduce((uniqueSearchQueries, current) => {
  const currentDecoded = current[0];
  const index = uniqueSearchQueries.findIndex(_ref4 => {
    let [decodedSearchQuery] = _ref4;
    return isEqual(decodedSearchQuery, currentDecoded, 'keywords') && isEqual(decodedSearchQuery, currentDecoded, 'where') && isEqual(decodedSearchQuery, currentDecoded, 'classification');
  });
  return index >= 0 ? uniqueSearchQueries : [...uniqueSearchQueries, current];
}, []).map(_ref5 => {
  let [_, encodedSearchQuery] = _ref5;
  return encodedSearchQuery;
});
const toEncodedSearchQueryString = (searchQuery, creationDate) => {
  const encodedParts = encoders.map(encode => encode(searchQuery, creationDate));
  const cookieObject = (0, _assign.default)(...encodedParts);
  const encodedCookieObject = (0, _mapValues.default)(cookieObject, (value, key) => {
    return key === 'OSF' ? value : encodeURIComponent(value);
  });
  return Object.keys(encodedCookieObject).map(key => `${key}${encodeURIComponent('|')}${encodedCookieObject[key].split('~')[0]}`).join('~');
};

/**
 *
 * @param {*} date Creation date for the new search query input
 * @param {*} query New search query to be prepended to the encoded output
 * @param {*} searchQueriesStr The existing cookie value. NOTE: this value can contain unencoded characters.
 * @returns
 */
exports.toEncodedSearchQueryString = toEncodedSearchQueryString;
function _default(date, query) {
  let searchQueriesStr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  const encodedSearchQueriesStr = searchQueriesStr.replace(new RegExp(/\|/, 'g'), '%7C').replace(new RegExp(/\s/, 'g'), '%20');
  const newSearchQueryEncodedStr = toEncodedSearchQueryString(query, date);
  const existingSearchQueries = toDecodedSearchQueries(encodedSearchQueriesStr);
  const searchQueriesWithNewSearch = [newSearchQueryEncodedStr, ...existingSearchQueries].filter(Boolean);
  return filterDuplicateSearchQueries(searchQueriesWithNewSearch).slice(0, 3).join(searchSeparator);
}